import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UsersPartialState } from './users.reducer';
import { UsersQuery } from './users.selectors';
import * as UsersActions from './users.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';
import { Invitation, User, B2bUnit, ContactFormData, Address } from '@kion/data-models';

@Injectable()
export class UsersFacade {

  all$ = this.store.pipe(select(UsersQuery.getAllUsers));
  allById$ = this.store.pipe(select(UsersQuery.getAllUsersById));
  searchResults$ = this.store.pipe(select(UsersQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(UsersQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(UsersQuery.getLastCreatedId));

  constructor(private store: Store<UsersPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  inviteUser(invitation: Invitation, isAdmin?: boolean, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(UsersActions.inviteUser({ invitation: invitation, isAdmin: isAdmin }), correlationId);
  }
  validateInvitationToken(
    email: string,
    token: string,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      UsersActions.validateInvitationToken({email: email, token: token}),
      correlationId
    );
  }
  registerUser(
    accessToken: string,
    identityToken: string,
    firstName: string,
    lastName: string,
    email: string,
    idp: string,
    oid: string,
    invitationToken?: string,
    address?: Partial<Address>,
    correlationId?: string
  ): ActionWithCorrelationAttributes {
    return this.dispatch(
      UsersActions.registerUser(
        {
          accessToken: accessToken,
          email: email,
          firstName: firstName,
          identityToken: identityToken,
          invitationToken: invitationToken,
          lastName: lastName,
          idp: idp,
          oid: oid,
          address: address
        }
      ),
      correlationId
    )
  }
  resendInvitation(invitationId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(UsersActions.resendInviteUser({ invitationId: invitationId }), correlationId);
  }
  deleteInvitation(invitationId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(UsersActions.deleteInvitation({ invitationId: invitationId }), correlationId);
  }
  loadUserById(correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      UsersActions.loadUserById(),
      correlationId
    );
  }
  updateB2bUnit(userId: string, registration: B2bUnit, correlationId?: string): ActionWithCorrelationAttributes {
    const b2bUnitId = userId + 'Unit';
    return this.dispatch(
      UsersActions.updateB2bUnit({ b2bUnitId, registration }),
      correlationId
    );
  }
  submitContactForm(data: ContactFormData, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      UsersActions.submitContactForm({ data: data }),
      correlationId
    );
  }
}
